import React from 'react';
import styled from '@emotion/styled';
import checkIcon from '../../../../../../Assets/Icons/check.svg';
import Icon from '../../../../../../Components/Icon';
import { useIsLandscape } from '~Scenes/SelfServiceKiosks/Hooks/useIsLandscape';

const Wrapper = styled.div<{ active: boolean }>`
  border: 1px solid ${(props) => (props.active ? '#000000' : 'rgb(224, 224, 227)')};
  height: 46px;
  width: 46px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? '#000000' : '#ffffff')};
  margin: 0 16px 0 0;

  @media (orientation: landscape) {
    height: 34px;
    width: 34px;
  }
`;

type Props = {
  active: boolean;
};

const CheckIcon = ({ active }: Props) => {
  const isLandscape = useIsLandscape();

  return (
    <Wrapper active={active}>
      <Icon icon={checkIcon} color={'#fff'} size={isLandscape ? 24 : 32} />
    </Wrapper>
  );
};

export default CheckIcon;
